(function () {
  if (window.__aseeloProductAccordionFixLoaded) return;
  window.__aseeloProductAccordionFixLoaded = true;

  var shippingHtml = '<div class="pd-policy-highlight"><strong>Delivery across India is expected within 4–5 days.</strong></div>' +
    '<p>Delivery timelines may vary by PIN code, courier serviceability and unforeseen transit delays. Use the estimate shown at checkout or in your order confirmation when available.</p>' +
    '<p>For tracking or delivery assistance, contact <a href="mailto:support@aseelo.in">support@aseelo.in</a> or <a href="https://wa.me/919930724242?text=Hi%20ASEELO%2C%20I%20need%20help%20with%20my%20order.">WhatsApp support</a>. Please keep your Order ID handy.</p>';

  var replacementHtml = '<p><strong>Damaged on delivery:</strong> Please inform us on the <strong>same day you receive the parcel</strong>. Share your Order ID and clear photos or a short video of the bag and packaging.</p>' +
    '<p>After the issue is reviewed, we will arrange a <strong>refund or replacement</strong> for an item received damaged.</p>' +
    '<p><strong>Damage within 15 days:</strong> If the bag becomes damaged within 15 days after delivery, contact our support team with your Order ID and photos. We will review the issue and arrange a replacement.</p>' +
    '<p>Contact <a href="mailto:support@aseelo.in">support@aseelo.in</a> or <a href="https://wa.me/919930724242?text=Hi%20ASEELO%2C%20I%20need%20help%20with%20a%20damaged%20bag.">WhatsApp support</a>. Please wait for our team’s instructions before sending the item back.</p>';

  function normalizedText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase().replace(/&/g, 'and');
  }

  function scopeInlineResets(container) {
    container.querySelectorAll('style').forEach(function (style) {
      if (style.dataset.aseeloResetScoped === 'true') return;
      var before = style.textContent || '';
      var after = before.replace(/(^|[,\s])\*(?=\s*\{)/g, '$1.pd-wrapper *');
      if (after !== before) style.textContent = after;
      style.dataset.aseeloResetScoped = 'true';
    });
  }

  function hasHeading(wrapper, phrases) {
    var nodes = wrapper.querySelectorAll('.pd-toggle-label, .pd-drop-title, .pd-section-title, .pd-section-toggle, summary');
    return Array.prototype.some.call(nodes, function (node) {
      var text = normalizedText(node.textContent);
      return phrases.some(function (phrase) { return text.indexOf(phrase) !== -1; });
    });
  }

  function createPolicyRow(title, bodyHtml, key) {
    var details = document.createElement('details');
    details.className = 'pd-section aseelo-policy-row';
    details.setAttribute('data-aseelo-policy', key);
    var summary = document.createElement('summary');
    summary.className = 'pd-section-toggle';
    summary.setAttribute('aria-expanded', 'false');
    summary.innerHTML = '<span class="pd-toggle-left"><span class="pd-toggle-label"></span></span>' +
      '<span class="pd-chevron" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><polyline points="6 9 12 15 18 9"></polyline></svg></span>';
    summary.querySelector('.pd-toggle-label').textContent = title;
    var body = document.createElement('div');
    body.className = 'pd-body-inner pd-policy-copy';
    body.innerHTML = bodyHtml;
    details.appendChild(summary);
    details.appendChild(body);
    details.addEventListener('toggle', function () {
      details.classList.toggle('is-open', details.open);
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
    return details;
  }

  function addPolicyRows(wrapper) {
    if (wrapper.querySelector('.aseelo-policy-accordion')) return;
    var shippingExists = hasHeading(wrapper, ['shipping and delivery']);
    var replacementExists = hasHeading(wrapper, ['warranty and replacement']);
    if (shippingExists && replacementExists) return;

    var block = document.createElement('div');
    block.className = 'pd-accordion aseelo-policy-accordion';
    block.setAttribute('data-aseelo-policy-accordion', '');

    if (!shippingExists) {
      block.appendChild(createPolicyRow('Shipping & Delivery', shippingHtml, 'shipping'));
    }
    if (!replacementExists) {
      block.appendChild(createPolicyRow('Warranty & Replacement', replacementHtml, 'replacement'));
    }
    wrapper.appendChild(block);
  }

  function initNativeDetails(wrapper) {
    wrapper.querySelectorAll('details.pd-section, details.pd-drop').forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      if (!summary) return;
      details.classList.toggle('is-open', details.open);
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.dataset.aseeloToggleBound === 'true') return;
      details.dataset.aseeloToggleBound = 'true';
      details.addEventListener('toggle', function () {
        details.classList.toggle('is-open', details.open);
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });
  }

  function initButtonAccordions(wrapper) {
    wrapper.querySelectorAll('button.pd-section-toggle').forEach(function (button, index) {
      var section = button.closest('.pd-section');
      if (!section || section.closest('details')) return;
      var body = Array.prototype.find.call(section.children, function (child) {
        return child.classList && child.classList.contains('pd-body');
      });
      if (!body) return;

      button.setAttribute('type', 'button');
      if (!body.id) body.id = 'aseelo-product-panel-' + Math.random().toString(36).slice(2, 9) + '-' + index;
      button.setAttribute('aria-controls', body.id);
      var open = section.classList.contains('is-open') || button.getAttribute('aria-expanded') === 'true';
      section.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
    });
  }

  function initAll() {
    var containers = document.querySelectorAll('body.template-product .product__description');
    containers.forEach(function (container) {
      scopeInlineResets(container);
      var wrappers = Array.prototype.filter.call(container.querySelectorAll('.pd-wrapper'), function (wrapper) {
        return !wrapper.parentElement.closest('.pd-wrapper');
      });
      wrappers.forEach(function (wrapper) {
        addPolicyRows(wrapper);
        initNativeDetails(wrapper);
        initButtonAccordions(wrapper);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('button.pd-section-toggle') : null;
    if (!button || button.closest('details')) return;
    var wrapper = button.closest('.product__description .pd-wrapper');
    if (!wrapper) return;
    var section = button.closest('.pd-section');
    if (!section) return;
    var body = Array.prototype.find.call(section.children, function (child) {
      return child.classList && child.classList.contains('pd-body');
    });
    if (!body) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var isOpen = section.classList.contains('is-open');
    section.classList.toggle('is-open', !isOpen);
    button.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    body.style.maxHeight = !isOpen ? body.scrollHeight + 'px' : '0px';
  }, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll('body.template-product .product__description .pd-section.is-open > .pd-body').forEach(function (body) {
      body.style.maxHeight = body.scrollHeight + 'px';
    });
  }, { passive: true });

  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();